import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login';
import { ChangePasswordComponent } from './pages/change-password/change-password';
import { DashboardComponent } from './pages/dashboard/dashboard';
import { ContentManagerComponent } from './pages/content-manager/content-manager';
import { AgentsComponent } from './pages/agents/agents';
import { MyTeamComponent } from './pages/my-team/my-team';
import { ConceptsComponent } from './pages/concepts/concepts';
import { ApplicationsComponent } from './pages/applications/applications';
import { InsightsComponent } from './pages/insights/insights';
import { SettingsComponent } from './pages/settings/settings';
import { SystemMonitorComponent } from './pages/system-monitor/system-monitor';
import { AudioLibraryComponent } from './pages/audio-library/audio-library';
import { VideoLibraryComponent } from './pages/video-library/video-library';
import { ImageGenerationComponent } from './pages/image-generation/image-generation';
import { ImageLibraryComponent } from './pages/image-library/image-library';
import { authGuard } from './core/guards/auth-guard';
import { adminGuard } from './core/guards/admin-guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [authGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'agents', component: AgentsComponent, canActivate: [authGuard, adminGuard] },
  { path: 'content-manager', component: ContentManagerComponent, canActivate: [authGuard] },
  { path: 'my-team', component: MyTeamComponent, canActivate: [authGuard] },
  { path: 'prompts', component: ConceptsComponent, canActivate: [authGuard] },
  { path: 'prompts/:appSlug', component: ConceptsComponent, canActivate: [authGuard] },
  {
    path: 'prompts/:appSlug/:conceptId',
    component: ConceptsComponent,
    canActivate: [authGuard],
    canDeactivate: [(component: ConceptsComponent) => component.canDeactivate()],
  },
  { path: 'concepts', redirectTo: 'prompts', pathMatch: 'full' },
  { path: 'concepts/:appSlug', redirectTo: 'prompts/:appSlug' },
  { path: 'applications', component: ApplicationsComponent, canActivate: [authGuard] },
  { path: 'insights', component: InsightsComponent, canActivate: [authGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
  { path: 'system-monitor', component: SystemMonitorComponent, canActivate: [authGuard] },
  { path: 'audio-library', component: AudioLibraryComponent, canActivate: [authGuard] },
  { path: 'video-library', component: VideoLibraryComponent, canActivate: [authGuard] },
  { path: 'image-generation', component: ImageGenerationComponent, canActivate: [authGuard] },
  { path: 'image-library', component: ImageLibraryComponent, canActivate: [authGuard] },
  { path: 'library', redirectTo: 'image-library', pathMatch: 'full' },
];
